import { useMemo } from 'react';

import { useThemeContext } from '../../../../contexts/ThemeContext';
import { resolveColor } from '../../theme/utils/resolveColor';
import QITechLogoMono from '../../theme/assets/qi_tech_logo_mono.svg'
import * as S from './styles';

export const BaseLoading = () => {
    const { clientThemeSettings } = useThemeContext();
    const spinDelayMs = useMemo(() => -(Date.now() % 1000), []);

    if (!clientThemeSettings) return <></>;

    const primary = resolveColor('primary', clientThemeSettings);
    const tertiary = resolveColor('tertiary', clientThemeSettings);
    const hasLogo = !!clientThemeSettings?.loading_logo_url;

    return (
        <S.PageWrapper $background={primary}>
            <S.SpinnerWrapper $hasLogo={hasLogo}>
                <S.Spinner $color={tertiary} $hasLogo={hasLogo} $spinDelayMs={spinDelayMs} />
                {hasLogo && (
                    <S.LogoImage src={clientThemeSettings.loading_logo_url} alt="logo" />
                )}
            </S.SpinnerWrapper>

            <S.PoweredByContainer>
                <img src={QITechLogoMono} width={18} height={18} alt="QI Tech" />
                <S.PoweredByText>Powered by</S.PoweredByText>
                <S.PoweredByBrand>QI Tech</S.PoweredByBrand>
            </S.PoweredByContainer>
        </S.PageWrapper>
    );
};
